import * as React from 'react';

import _ from 'lodash';

import timezones from 'bundles/common/constants/timezones';

type Props = {
  defaultValue: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
};

const TimezoneSelect = ({ defaultValue, onChange }: Props) => (
  <select
    key={`timezoneSelect~${defaultValue}`}
    name="timezone"
    id="settings-basic-timezone"
    defaultValue={defaultValue}
    onChange={onChange}
    autoComplete="on"
  >
    {_.map(timezones(), (timezoneGroup) => (
      <optgroup label={timezoneGroup.groupName} key={timezoneGroup.groupName}>
        {_.map(timezoneGroup.zones, (value, name) => (
          <option key={`${name}~${value}`} value={value}>
            {name}
          </option>
        ))}
      </optgroup>
    ))}
  </select>
);

export default TimezoneSelect;
